import React from 'react'

import { Box, Typography, Checkbox } from '@material-ui/core'

const PaymentMethodCheckbox = ({
  id,
  image,
  imageAlt,
  description,
  ...rest
}) => {
  return (
    <Box
      display="flex"
      width="min-content"
      alignItems="flex-start"
      justifyContent="center"
      component="label"
      htmlFor={id}
    >
      <Checkbox id={id} {...rest} />

      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <Box width={80} component="img" src={image} alt={imageAlt} />

        <Typography color="textSecondary" align="center">
          <Box component="span" fontWeight="fontWeightMedium">
            {description}
          </Box>
        </Typography>
      </Box>
    </Box>
  )
}

export default PaymentMethodCheckbox
